import DashboardView from '@/features/dashboard/views/DashboardView.vue'
import FaqView from '@/features/faq/views/FaqView.vue'
import LiveStreamingView from '@/features/live-streaming/views/LiveStreamingView.vue'
import GoogleLogin from '@/features/login/views/callback/GoogleLogin.vue'
import KakaoLogin from '@/features/login/views/callback/KakaoLogin.vue'
import NaverLogin from '@/features/login/views/callback/NaverLogin.vue'
import LoginView from '@/features/login/views/LoginView.vue'
import SignupView from '@/features/login/views/SignupView.vue'
import MentorDetailView from '@/features/mentor/views/MentorDetailView.vue'
import MentorView from '@/features/mentor/views/MentorView.vue'
import MyClassView from '@/features/my-class/views/MyClassView.vue'
import MyAdsView from '@/features/my/views/MyAdsView.vue'
import MyView from '@/features/my/views/MyView.vue'
import OnlineClassView from '@/features/online-class/views/OnlineClassView.vue'
import OpenClassView from '@/features/open-class/views/OpenClassView.vue'
import PostDetailView from '@/features/open-class/views/PostDetailView.vue'
import ProgramView from '@/features/program/views/ProgramView.vue'
import VideoView from '@/features/video/views/VideoView.vue'
import { useAuthStore } from '@/stores/auth'
import HomeView from '@/views/HomeView.vue'
import PrivacyTermsView from '@/views/PrivacyTermsView.vue'
import UseTermsView from '@/views/UseTermsView.vue'
import { createRouter, createWebHistory } from 'vue-router'

declare module 'vue-router' {
  interface RouteMeta {
    hideHeader?: boolean
    requiresAuth?: boolean
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'main',
      component: HomeView,
      meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/use-terms',
      name: 'use-terms',
      component: UseTermsView,
      meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/privacy-terms',
      name: 'privacy-terms',
      component: PrivacyTermsView,
      meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        requireAuth: false,
        hideHeader: true,
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignupView,
      meta: {
        requireAuth: false,
      }
    },
    {
      path: '/kakao-login',
      name: 'kakao-login',
      component: KakaoLogin,
      meta: {
        requireAuth: false,

      }
    },
    {
      path: '/google-login',
      name: 'google-login',
      component: GoogleLogin,
      meta: {
        requireAuth: false,

      }
    },
    {
      path: '/naver-login',
      name: 'naver-login',
      component: NaverLogin,
      meta: {
        requireAuth: false,

      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/program',
      name: 'program',
      component: ProgramView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/open-class',
      name: 'open-class',
      component: OpenClassView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/post/:id',
      name: 'post-detail',
      component: PostDetailView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/mentor',
      name: 'mentor',
      component: MentorView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/mentor/:id',
      name: 'mentor-detail',
      component: MentorDetailView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/online-class',
      name: 'online-class',
      component: OnlineClassView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/live-streaming/:id',
      name: 'live-streaming',
      component: LiveStreamingView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/my-class',
      name: 'my-class',
      component: MyClassView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: FaqView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/my',
      name: 'my',
      component: MyView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/my/ads',
      name: 'my-ads',
      component: MyAdsView,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/video/:id',
      name: 'video-detail',
      component: VideoView,
      meta: {
        requiresAuth: true,
      }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const { isAuthenticated } = useAuthStore()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  const { isAuthenticated } = useAuthStore()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isAuthenticated) {
    router.push('/login')
  }
})

export default router
